import { ApiConfig } from "./apiConfig";

export const get_expenses = async (data) => {
    try {
        const response = await ApiConfig.post(`getExpenseHistories`,data);
        return response;
    } catch (error) {
        throw error;
    }
};

export const get_expense_by_id = async (expense_history_id) => {
    try {
        const response = await ApiConfig.post(`viewExpenseHistory`,{expense_history_id});
        return response;
    } catch (error) {
        throw error;
    }
};

export const create_expense = async (data) => {
    try {
        const response = await ApiConfig.post(`storeExpenseHistory`,data,{ headers: { "Content-Type": "multipart/form-data" }});
        return response;
    } catch (error) {
        throw error;
    }
};

export const update_expense = async (data) => {
    try {
        const response = await ApiConfig.post(`updateExpenseHistory`,data,{ headers: { "Content-Type": "multipart/form-data" }});
        return response;
    } catch (error) {
        throw error;
    }
};
//updateExpenseDocuments
export const update_expense_document = async (data) => {
    try {
        const response = await ApiConfig.post(`updateExpenseDocuments`,data,{ headers: { "Content-Type": "multipart/form-data" }});
        return response;
    } catch (error) {
        throw error;
    }
};
export const delete_expense = async (expense_history_id) => {
    try {
        const response = await ApiConfig.post(`deleteExpenseHistory`,{expense_history_id});
        return response;
    } catch (error) {
        throw error;
    }
};
